// @flow
import React, { Fragment, useState, type Node } from 'react';
import classnames from 'classnames';

import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import { Backdrop } from 'Components/frameworks/backdrop/Backdrop.jsx';
import Image from 'Components/frameworks/image/Image.jsx';

type MapProps = {
  children?: Node,
  className?: string,
  closeLabel?: string,
  dataTestId?: string,
  imageSrc: string,
  ratio?: {
    w: number,
    h: number,
  },
  title?: string,
  trackingData?: TrackingData,
};

export function Map(props: MapProps) {
  const {
    children,
    className,
    closeLabel,
    dataTestId,
    imageSrc,
    ratio = {
      w: 29,
      h: 32,
    },
    title,
    trackingData,
  } = props;

  const [isOpen, setOpen] = useState(false);

  if (!imageSrc) return null;

  return (
    <Fragment>
      <TrackClick
        as="button"
        className={classnames(
          className,
          'reset-button block cursor-pointer overflow-hidden relative w-full image-responsive-cell',
        )}
        onClick={() => setOpen(true)}
        trackingData={!isOpen ? trackingData : null}
        type="button"
        data-testid={dataTestId}
      >
        <Image forceImage imageUrl={imageSrc} mandatoryWidthAndHeight={ratio} />
      </TrackClick>
      {isOpen && (
        <Backdrop
          ariaLabel={title}
          closeLabel={closeLabel}
          hasCloseButton
          onClose={() => setOpen(false)}
        >
          <div className="flex-1 h-full">{children}</div>
        </Backdrop>
      )}
    </Fragment>
  );
}
